import { default as banned14n6xj7egdMeta } from "/app/pages/banned.vue?macro=true";
import { default as index7ZtduOIoVXMeta } from "/app/pages/checkout/index.vue?macro=true";
import { default as contactV6oPJjs9RyMeta } from "/app/pages/contact.vue?macro=true";
import { default as privacypL3A7816ocMeta } from "/app/pages/content/privacy.vue?macro=true";
import { default as tokusyoDmAy74QJR3Meta } from "/app/pages/content/tokusyo.vue?macro=true";
import { default as tos7GBA7wgE6BMeta } from "/app/pages/content/tos.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as indexPe5fhFjlrWMeta } from "/app/pages/mypage/index.vue?macro=true";
import { default as profile2pxfQ9S8FiMeta } from "/app/pages/mypage/profile.vue?macro=true";
import { default as indexza3GsmUuTtMeta } from "/app/pages/order/[id]/index.vue?macro=true";
import { default as invoiceZXCwg2hlJKMeta } from "/app/pages/order/[id]/invoice.vue?macro=true";
import { default as receiptMX67eHnVIPMeta } from "/app/pages/order/[id]/receipt.vue?macro=true";
import { default as indexCICQ7TchH0Meta } from "/app/pages/order/index.vue?macro=true";
import { default as _91id_93kVZKMJ3tbEMeta } from "/app/pages/products/[id].vue?macro=true";
import { default as index18IXo8oN8QMeta } from "/app/pages/products/index.vue?macro=true";
import { default as indexBwMFoD6UQIMeta } from "/app/pages/reserve/[id]/index.vue?macro=true";
import { default as invoicee4fNFpjpFCMeta } from "/app/pages/reserve/[id]/invoice.vue?macro=true";
import { default as receiptUjyKJaJHSxMeta } from "/app/pages/reserve/[id]/receipt.vue?macro=true";
import { default as applyaKNT4jvuEpMeta } from "/app/pages/reserve/apply.vue?macro=true";
import { default as index5ADbwM93xzMeta } from "/app/pages/reserve/index.vue?macro=true";
import { default as _91id_93a915RmbTVoMeta } from "/app/pages/tours/[id].vue?macro=true";
import { default as indexkXHLoIV36qMeta } from "/app/pages/tours/index.vue?macro=true";
export default [
  {
    name: "app__banned",
    path: "/banned",
    meta: banned14n6xj7egdMeta || {},
    component: () => import("/app/pages/banned.vue").then(m => m.default || m)
  },
  {
    name: "app__checkout__new",
    path: "/checkout",
    meta: index7ZtduOIoVXMeta || {},
    component: () => import("/app/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: "app__contact",
    path: "/contact",
    meta: contactV6oPJjs9RyMeta || {},
    component: () => import("/app/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: "app__content__privacy",
    path: "/content/privacy",
    meta: privacypL3A7816ocMeta || {},
    component: () => import("/app/pages/content/privacy.vue").then(m => m.default || m)
  },
  {
    name: "app__content__tokusyo",
    path: "/content/tokusyo",
    meta: tokusyoDmAy74QJR3Meta || {},
    component: () => import("/app/pages/content/tokusyo.vue").then(m => m.default || m)
  },
  {
    name: "app__content__tos",
    path: "/content/tos",
    meta: tos7GBA7wgE6BMeta || {},
    component: () => import("/app/pages/content/tos.vue").then(m => m.default || m)
  },
  {
    name: "app__index",
    path: "/",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "app__mypage__index",
    path: "/mypage",
    meta: indexPe5fhFjlrWMeta || {},
    component: () => import("/app/pages/mypage/index.vue").then(m => m.default || m)
  },
  {
    name: "app__mypage__profile",
    path: "/mypage/profile",
    meta: profile2pxfQ9S8FiMeta || {},
    component: () => import("/app/pages/mypage/profile.vue").then(m => m.default || m)
  },
  {
    name: "app__order__id",
    path: "/order/:id()",
    meta: indexza3GsmUuTtMeta || {},
    component: () => import("/app/pages/order/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "app__order__invoice",
    path: "/order/:id()/invoice",
    meta: invoiceZXCwg2hlJKMeta || {},
    component: () => import("/app/pages/order/[id]/invoice.vue").then(m => m.default || m)
  },
  {
    name: "app__order__receipt",
    path: "/order/:id()/receipt",
    meta: receiptMX67eHnVIPMeta || {},
    component: () => import("/app/pages/order/[id]/receipt.vue").then(m => m.default || m)
  },
  {
    name: "app__order__index",
    path: "/order",
    meta: indexCICQ7TchH0Meta || {},
    component: () => import("/app/pages/order/index.vue").then(m => m.default || m)
  },
  {
    name: "app__products__id",
    path: "/products/:id()",
    meta: _91id_93kVZKMJ3tbEMeta || {},
    component: () => import("/app/pages/products/[id].vue").then(m => m.default || m)
  },
  {
    name: "app__products__index",
    path: "/products",
    meta: index18IXo8oN8QMeta || {},
    component: () => import("/app/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: "app__reserve__id",
    path: "/reserve/:id()",
    meta: indexBwMFoD6UQIMeta || {},
    component: () => import("/app/pages/reserve/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "app__reserve__invoice",
    path: "/reserve/:id()/invoice",
    meta: invoicee4fNFpjpFCMeta || {},
    component: () => import("/app/pages/reserve/[id]/invoice.vue").then(m => m.default || m)
  },
  {
    name: "app__reserve__receipt",
    path: "/reserve/:id()/receipt",
    meta: receiptUjyKJaJHSxMeta || {},
    component: () => import("/app/pages/reserve/[id]/receipt.vue").then(m => m.default || m)
  },
  {
    name: "app__reserve__apply",
    path: "/reserve/apply",
    meta: applyaKNT4jvuEpMeta || {},
    component: () => import("/app/pages/reserve/apply.vue").then(m => m.default || m)
  },
  {
    name: "app__reserve__index",
    path: "/reserve",
    meta: index5ADbwM93xzMeta || {},
    component: () => import("/app/pages/reserve/index.vue").then(m => m.default || m)
  },
  {
    name: "app__tours__id",
    path: "/tours/:id()",
    meta: _91id_93a915RmbTVoMeta || {},
    component: () => import("/app/pages/tours/[id].vue").then(m => m.default || m)
  },
  {
    name: "app__tours__index",
    path: "/tours",
    meta: indexkXHLoIV36qMeta || {},
    component: () => import("/app/pages/tours/index.vue").then(m => m.default || m)
  }
]